/**
 * Letters Settings Component
 * Level selector for the Letters game
 */

import PillSelect from './PillSelect'
import { useSettingsStore } from '@stores/settingsStore'
import { LETTERS_ITEMS, LETTERS_PREVIEW_COUNT } from '@data/letters'

interface LettersSettingsProps {
  isOpen: boolean
  onToggle: (open: boolean) => void
}

export default function LettersSettings({ isOpen, onToggle }: LettersSettingsProps) {
  const settings = useSettingsStore(state => state.settings)
  const updateLettersPractice = useSettingsStore(state => state.updateLettersPractice)

  const levelOptions: { value: 1 | 2 | 3; label: string; shortLabel: string }[] = [
    { value: 1, label: 'Level 1 - Starting letter', shortLabel: 'Level 1' },
    { value: 2, label: 'Level 2 - Vowel', shortLabel: 'Level 2' },
    { value: 3, label: 'Level 3 - Full word', shortLabel: 'Level 3' },
  ]

  return (
    <details
      className="config__section"
      open={isOpen}
      onToggle={e => onToggle(e.currentTarget.open)}
    >
      <summary className="config__section-summary">
        <span className="config__section-title">Letters</span>
      </summary>
      <fieldset className="config__group config__group--framed">
        <legend>Letters practice options</legend>
        <p className="config__hint config__hint--spaced">
          Choose what to fill in for the CVC word (first letter, vowel, or the whole word).
        </p>
        <div className="config__operations-grid">
          <div className="config__operation-tile">
            <div className="config__operation-expanded">
              <div className="config__operation-header">
                <span className="config__operation-label">Level</span>
              </div>
              <div className="config__operation-body">
                <PillSelect<number>
                  label="Level"
                  ariaLabel="Letters practice level"
                  value={settings.lettersPractice.level}
                  options={levelOptions}
                  onChange={value =>
                    updateLettersPractice({ level: value as (1 | 2 | 3) })
                  }
                  icon="🔤"
                />
                <p className="config__hint config__hint--inline">
                  Level 1: first letter. Level 2: vowel. Level 3: full word.
                </p>
                <details className="config__word-preview">
                  <summary className="config__word-preview-summary">
                    <span className="config__operation-subtitle">Preview</span>
                    <span className="config__operation-hint">CVC words used in this set.</span>
                  </summary>
                  <ul className="config__word-preview-list">
                    {LETTERS_ITEMS.slice(0, LETTERS_PREVIEW_COUNT).map(item => (
                      <li key={item.word}>{item.word}</li>
                    ))}
                  </ul>
                </details>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
    </details>
  )
}
